export default "__VITE_PUBLIC_ASSET__9b3964e9__"